import $ from "jquery"
import "./../tools/addClassAt.coffee"

buttonFilterList = []

class ButtonFilter

    constructor: (@$el, @filters, @value) ->

        buttonFilterList.push @

        @$el.click (e) =>
            e.preventDefault()

            if @$el.hasClass "active"
                @unset()
            else
                @set()

        if @isSet() then @$el.addClass "active"


    set: ->
        for other in buttonFilterList
            other.$el.removeClass "active"

        for filter, value of @filters
            $input = $("[name='" + filter + "']")
            if $input.length
                $input.val(value).change()

        @$el.addClass "active"

    unset: ->
        if @$filter && @$filter.length
            @$filter.val(null).change()

        @$el.removeClass "active"

    isSet: ->
        for filter, value of @filters
            $input = $("[name='" + filter + "']")
            unless $input.length then return false
            if $input.val() != value then return false
        return true

# ==================================================
# > FILTER LABELS
# ==================================================
class Filter

    constructor: (@$el, @archive) ->
        @$el.change =>
            @archive.updateFilters()
            @refreshLabel()

        @$label    = $("<li class='filter-label'></li>")
        @labelTxt  = @$el.data("label") || "#"
        @value     = false

        @refreshLabel()

    clear: ->
        @$el.val("").change()

    getValue: ->
        unless @$el.is("select") then return @$el.val()

        val = false
        @$el.find("option").each (i, el) =>
            if $(el).attr("value") == @$el.val()
                val = $(el).html()
        return val

    refreshLabel: ->
        @value = @getValue()
        if @value
            @$label.html @labelTxt.replace "#", @getValue()
            @archive.$labels.append @$label.unbind("click").click => @clear()
        else
            @$label.remove()

# ==================================================
# > CLASSES
# ==================================================
class ArchiveImmo
    constructor: (@$filters) ->

        @$list   = @$filters.next(".container").find(".archive-immo")
        @$labels = @$filters.find(".filters-labels")

        # ========== FILTERING ========== #
        @filters = []
        @$filters.find("input, select").each (i, el) =>
            if $(el).hasClass("archive-immo-filters__filter")
                @filters.push new Filter $(el), @

        @$filters.submit (e) =>
            e.preventDefault()
            @updateFilters()

        @updateFilters {}, false

        # ========== LOADING ========== #
        @$more   = @$list.next ".archive-immo-more"
        @$roots  = $("html, body")
        @$body   = $("body")
        @page    = 2
        @limit   = @$list.data("perpage")
        @loading = false
        @finish  = false

        @$list.on "click", ".no-more span", =>
            @$roots.animate
                "scrollTop": @$list.offset().top
            , 500

        @scrollBinds()
        @$body.addClass "no-footer"

        # ========== RESPONSIVE ========== #
        @$filters.after().click =>
            @$body.toggleClass "show-sidebar"

    scrollBinds: ->
        # fixed sidebar
        @$filters.addClassAt @$filters.offset().top - parseInt($("html").css("margin-top")), "fixed"

        # autoload
        $(window).scroll (e) =>
            scroll = $(e.target).scrollTop() + $(e.target).innerHeight() / 2
            if @$more.offset().top < scroll then @more()


    # ==================================================
    # > FILTERING
    # ==================================================
    reset: ->
        @loading = false
        @finish  = false
        @page    = 1

        @$list.html ""
        @$body.addClass "no-footer"

        @$roots.animate
            "scrollTop": @$list.offset().top
        , 500, => @more()

    updateFilters: (defaultFilters = {}, reset = true) ->
        @filters = defaultFilters
        _filters = @$filters.serializeArray()

        delete _filters[11]

        $.each _filters, (i, f) => if f && f.value then @filters[f.name] = f.value

        history.replaceState {}, "", "?" + $.param @filters

        if reset then @reset()




    # ==================================================
    # > LOADING
    # ==================================================
    add: ($items) ->

        @$list.append $items

        $items.each (i, el) ->
            $(el).addClass "delay-" + i

        $items.addClass("hidden").hide().slideDown 250
        setTimeout ->
            $items.removeClass "hidden"
        , 260

    more: ->
        unless @loading or @finish
            # before
            @loading = true
            @$more.addClass "loading"

            # load
            $.ajax
                url: ajaxurl
                method: "GET"
                data:
                    action: "more-immo"
                    limit: @limit
                    page: @page
                    filters: @filters

                success: (html) =>
                    $items = $(html)

                    if $items.filter(".no-result, .no-more").length
                        @finish = true
                        @$body.removeClass "no-footer"

                    @add $items
                    @page++

                complete: =>
                    @loading = false
                    @$more.removeClass "loading"

                error: (a, b) ->
                    console.log a
                    console.log b



# ==================================================
# > INIT
# ==================================================
$ ->
    if $(".archive-immo-filters").length

        archive = new ArchiveImmo $(".archive-immo-filters")

        new ButtonFilter $("#button-sell"),
            goal: "0"
            marquee: ""

        new ButtonFilter $("#button-rent"),
            goal: "1"
            marquee: ""

        new ButtonFilter $("#button-sold"),
            goal: ""
            marquee: "3"


// WEBPACK FOOTER //
// ./scripts/modules/archive-immo.coffee